import constants from '@client-shared/config/constants.js'
import Document from '@client-shared/models/document.model.js'
import ParticipantVirtual from '@client-shared/models/participant-virtual.model.js'
import Plan from '@client-shared/models/plan.model.js'
import { getParticipantNameSearchSegments } from '@client-shared/utils/search-helpers.js'

export default ({ item, project, getPfFileById }) => {
  if (!project) {
    console.error('project must be passed to matchesFilterText function')

    return
  }

  if (!(item instanceof Plan) && !(item instanceof Document)) {
    console.error('Plan or Document instance have to passed to matchFilterText')

    return
  }

  if (!getPfFileById) {
    console.error('getPfFileById function must be passed to matchesFilterText')

    return
  }

  const latestRevision = item.revisions[item.revisions.length - 1]

  let authorParticipant

  if (item.author.userId) {
    authorParticipant = project.findParticipantByUserId(item.author.userId)
  } else if (item.author.role) {
    authorParticipant = new ParticipantVirtual({
      roles: [ item.author.role ],
    })
  }

  const latestUploadParticipant = project.findParticipantByUserId(latestRevision.createdby)
  let approverStrings = []

  // generate approver strings
  if (latestRevision.approval && latestRevision.approval.requested && latestRevision.approval.by) {
    approverStrings = latestRevision.approval.by.flatMap(approver => {
      const participant = project.findParticipantById(approver.participantid)

      return [
        ...getParticipantNameSearchSegments(participant),
        participant.roles[0],
      ]
    })
  }

  let documentPfFile

  if (latestRevision.pfFileIds?.[0]) {
    documentPfFile = getPfFileById(latestRevision.pfFileIds?.[0])
  }

  let planPfFile

  if (latestRevision.pdfPfFileId) {
    planPfFile = getPfFileById(latestRevision.pdfPfFileId)
  }

  let dwgPfFile

  if (latestRevision.dwgPfFileId) {
    dwgPfFile = getPfFileById(latestRevision.dwgPfFileId)
  }

  const searchIndexes = [
    item.name,
    item.content,
    item.phasetag,
    ...item.tags,
    documentPfFile?.fileName || '',
    planPfFile?.fileName || '',
    dwgPfFile?.fileName || '',
    latestRevision.index,
    ...authorParticipant.roles,
    authorParticipant.company,
    ...getParticipantNameSearchSegments(latestUploadParticipant),
    ...approverStrings,
  ]

  if ((project.topCategoriesDocumentsEnabled && item instanceof Document) ||
    (project.topCategoriesPlansEnabled && item instanceof Plan)) {
    searchIndexes.push(item.topCategory)
  }

  if (item.permission && item.permission.restricted && item.permission.users && item.permission.users.length > 0) {
    for (const userId of item.permission.users) {
      const participant = project.findParticipantByUserId(userId)

      searchIndexes.push(...getParticipantNameSearchSegments(participant))
    }
  }

  return searchIndexes
    .filter(Boolean)
    .join(constants.SEARCH_INDEX_SEPARATOR)
}
